module Meevo.Plugins.MembershipDefinitions {
    "use strict";
    
    /**
    *  Docs and forms section of Membership Definitions   
    */    

    export class DocsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Employee> { }


}